export const GET_LAST_DEADLINE_DATES_FAILURE = 'GET_LAST_DEADLINE_DATES_FAILURE';

export const getLastDeadlineDatesFailure = error => ({
    type: GET_LAST_DEADLINE_DATES_FAILURE,
    payload: error,
    error: true,
});
